export const ModalActionTypes = {
  OPEN_MODAL: 'zola/cards/modal/OPEN_MODAL',
  HIDE_MODAL: 'zola/cards/modal/HIDE_MODAL',
  UPDATE_MODAL_OPTIONS: 'zola/modal/UPDATE_MODAL_OPTIONS',
  FLIP_FORMAT_FLAG: 'zola/cards/modal/FLIP_FORMAT_FLAG',
  IS_BUSY: 'zola/cards/modal/IS_BUSY',
};

export default ModalActionTypes;
